import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Route mapping for breadcrumb labels
  const routeLabels = {
    '/employee-shift-calendar': 'Dashboard',
    '/available-shifts-booking': 'Book Shifts',
    '/personal-availability-management': 'Availability',
    '/my-assigned-shifts': 'My Shifts',
    '/admin-schedule-management-dashboard': 'Admin Dashboard',
    '/shift-creation-and-editing': 'Manage Shifts',
    '/system-settings-and-configuration': 'Settings',
    '/google-o-auth-login': 'Login'
  };

  // Generate breadcrumb items from current path
  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Home', path: '/employee-shift-calendar' }];

    if (pathSegments?.length > 0) {
      const currentPath = location?.pathname;
      const currentLabel = routeLabels?.[currentPath];
      
      if (currentLabel && currentPath !== '/employee-shift-calendar') {
        breadcrumbs?.push({ label: currentLabel, path: currentPath });
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Don't show breadcrumbs on login page or if only home
  if (location?.pathname === '/google-o-auth-login' || breadcrumbs?.length <= 1) {
    return null;
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
          )}
          {index === breadcrumbs?.length - 1 ? (
            <span className="text-foreground font-medium" aria-current="page">
              {crumb?.label}
            </span>
          ) : (
            <Button
              variant="ghost"
              onClick={() => handleNavigation(crumb?.path)}
              className="p-0 h-auto font-normal text-muted-foreground hover:text-foreground transition-colors"
            >
              {crumb?.label}
            </Button>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;